//#region header */
/**************************************************************************************************
//
//  Description: Hook to fetch organisations.
//
//  Copyright:    © 2026 Idox Software Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//#region Version 1.0.0.0 changes
//    001   05.02.26 Sean Flook         GMSCM-12 Initial Revision.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

import { useQuery } from "@tanstack/react-query";
import SecurityAPIClient from "../services/securityApiClient";
import ms from "ms";
import useUserQueryStore from "../context/UserStore";

const useOrganisations = () => {
  const currentToken = useUserQueryStore((s) => s.userQuery.currentToken);
  const securityAPIClient = new SecurityAPIClient<string>("/organisation", currentToken);

  return useQuery({
    queryKey: ["organisations"],
    queryFn: securityAPIClient.getAll,
    staleTime: ms("24h"),
  });
};

export default useOrganisations;
